import { ForbiddenError, UnauthorizedError, UnexpectedError } from '../errors';

import { ACCEPT_TERMS_URL } from '@/constants';
import { HttpStatusCode, fromBff, httpClient } from '@/utils';

export const acceptTermsService = async (): Promise<void> => {
  const httpsResponse = await httpClient.post(fromBff(ACCEPT_TERMS_URL), {});

  switch (httpsResponse.status) {
    case HttpStatusCode.created:
      return;

    case HttpStatusCode.unauthorized:
      throw new UnauthorizedError();

    case HttpStatusCode.forbidden:
      throw new ForbiddenError('Você não possui permissão para isto.');

    default:
      throw new UnexpectedError();
  }
};
